import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { WrapperWithScroll } from '@/common/styles/Wrappers';
import QuizReportSearchBox from './components/QuizReportSearchBox';
import useQuizReport from './hooks/useQuizReport';
import { getQuizReportTableHeaders } from './helpers/getTableHeaders';
import {
	getQuizReportRawEventsTableRows,
	getQuizNamedEventsTableRows,
} from './helpers/getTableRows';

const QuizReport = () => {
	const hook = useQuizReport();
	const tableNamedEventsRows = getQuizNamedEventsTableRows(hook.data);
	const tableRawEventNamesRows = getQuizReportRawEventsTableRows(hook.data);

	return (
		<>
			{hook.isLoading && <Loading />}
			<WrapperWithScroll>
				<QuizReportSearchBox
					handleSearchCallback={hook.fetchQuizReportData}
				></QuizReportSearchBox>
				{hook.data && (
					<>
						<Table
							className='styled-table'
							raws={tableNamedEventsRows}
							headers={getQuizReportTableHeaders()}
						/>
						<Table
							className='styled-table'
							raws={tableRawEventNamesRows}
							headers={getQuizReportTableHeaders()}
						/>
					</>
				)}
			</WrapperWithScroll>
		</>
	);
};

export default QuizReport;
